import { TextField } from "@mui/material";
import { AUTH_INPUT_BG, AUTH_INPUT_BORDER, AUTH_TEXT_PRIMARY, BRAND_BLUE } from "../theme/appTheme";

// TextField pre-styled for the auth screens — reused by every auth form
// instead of repeating the same sx override in each one.
function DarkTextField(props) {
  return (
    <TextField
      variant="outlined"
      fullWidth
      size="small"
      sx={{
        "& .MuiOutlinedInput-root": {
          bgcolor: AUTH_INPUT_BG,
          color: AUTH_TEXT_PRIMARY,
          borderRadius: 1.5,
          "& fieldset": { borderColor: AUTH_INPUT_BORDER },
          "&:hover fieldset": { borderColor: "#9ca3af" },
          "&.Mui-focused fieldset": { borderColor: BRAND_BLUE },
        },
        "& .MuiInputBase-input::placeholder": {
          color: "#9ca3af",
          opacity: 1,
        },
        "& .MuiSvgIcon-root": { color: "#6b7280" },
      }}
      {...props}
    />
  );
}

export default DarkTextField;
